import { useCallback, useEffect, useState } from 'react';
import { VoiceConnectionType, VoicePreference } from '../../services/cxone-sdk.service';
import {
  buildVoicePreference,
  clearSavedVoicePreference,
  loadSavedVoicePreference,
  saveVoicePreference,
} from '../../hooks/settings/useVoicePreferenceStorage';

interface UseVoicePreferencesFormOptions {
  onConnect: (preference: VoicePreference) => void;
  error?: string | null;
}

export function useVoicePreferencesForm({ onConnect, error }: UseVoicePreferencesFormOptions) {
  const savedPref = loadSavedVoicePreference();

  const [selectedType, setSelectedType] = useState<VoiceConnectionType>(
    savedPref?.type || 'softphone'
  );
  const [phoneNumber, setPhoneNumber] = useState(savedPref?.phoneNumber || '');
  const [stationId, setStationId] = useState(savedPref?.stationId || '');
  const [rememberChoice, setRememberChoice] = useState(!!savedPref);

  const handleConnect = useCallback(() => {
    const preference = buildVoicePreference(selectedType, phoneNumber, stationId);

    if (rememberChoice) {
      saveVoicePreference(preference);
    } else {
      clearSavedVoicePreference();
    }

    onConnect(preference);
  }, [onConnect, phoneNumber, rememberChoice, selectedType, stationId]);

  useEffect(() => {
    if (savedPref && !error) {
      const timer = setTimeout(() => {
        handleConnect();
      }, 500);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    selectedType,
    setSelectedType,
    phoneNumber,
    setPhoneNumber,
    stationId,
    setStationId,
    rememberChoice,
    setRememberChoice,
    handleConnect,
  };
}
